import React from "react";
import { Lifebuoy } from "@phosphor-icons/react";
import { CcPanel, AnimatedValue } from "./CcPanel";
import { C, PERIODS, num } from "./ccUtils";

function waited(iso) {
  const m = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (m < 60) return `${m} min`;
  if (m < 1440) return `${Math.floor(m / 60)} h`;
  return `${Math.floor(m / 1440)} d ${Math.floor((m % 1440) / 60)} h`;
}

function Tile({ label, value, color, testid, children }) {
  return (
    <div className="rounded-lg bg-[#171717] border border-neutral-800 px-3 py-2" data-testid={testid}>
      <div className="text-[10px] font-mono uppercase tracking-wider text-neutral-500">{label}</div>
      <AnimatedValue value={num(value)} testid={`${testid}-value`} className="font-heading text-[30px] font-bold tabular-nums leading-none mt-1.5" style={{ color }} />
      <div className="text-[11px] mt-1.5 truncate">{children}</div>
    </div>
  );
}

export function SupportPanel({ tickets }) {
  const { open, overdue, completed } = tickets;
  return (
    <CcPanel title="Support tickets" icon={Lifebuoy} testid="panel-support-tickets" className="h-[136px]" delay={0.15}
      aside={open > 0 && tickets.oldest_open_at && <span data-testid="tickets-oldest">Oldest waiting {waited(tickets.oldest_open_at)}</span>}>
      <div className="grid grid-cols-2 gap-2.5">
        <Tile label="Outstanding" value={open} color={open ? C.amber : C.muted} testid="tickets-outstanding">
          <span data-testid="tickets-overdue" style={{ color: overdue ? C.red : "#737373" }}>
            {overdue ? `${num(overdue)} overdue · waiting ${tickets.overdue_hours}h+` : "None overdue"}
          </span>
        </Tile>
        <Tile label="Completed · all time" value={completed.all} color={completed.all ? C.green : C.muted} testid="tickets-completed">
          <span className="text-neutral-500 font-mono text-[10px]" data-testid="tickets-completed-periods">
            {PERIODS.slice(0, 3).map((p) => `${p.label} ${num(completed[p.key])}`).join(" · ")}
          </span>
        </Tile>
      </div>
    </CcPanel>
  );
}
